import Platform from 'quasar/src/plugins/Platform.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QFile from 'quasar/src/components/file/QFile.js';import QInput from 'quasar/src/components/input/QInput.js';import QSelect from 'quasar/src/components/select/QSelect.js';

export const setQSelectError = (element: HTMLInputElement|QSelect|null, errorMessage?: string|null) => {
    if (!element) {
        return 
    }

    const qInput = (element as QSelect)
    const htmlInput = (element as HTMLInputElement)
    const id: string = (qInput?.$attrs.id as string|undefined) ?? htmlInput?.id 
    const name: string = (qInput?.$attrs.name as string|undefined) ?? htmlInput?.name

    setMyLabelClass(id, name, errorMessage)
}

export const setQInputError = (element: HTMLInputElement|QInput|null, errorMessage?: string|null) => {
    if (!element) {
        return 
    }

    const qInput = (element as QInput)
    const htmlInput = (element as HTMLInputElement)
    const id: string = (qInput?.$attrs.id as string|undefined) ?? qInput?.nativeEl.id ?? htmlInput?.id 
    const name: string = (qInput?.$attrs.name as string|undefined) ?? qInput?.nativeEl.name ?? htmlInput?.name

    setMyLabelClass(id, name, errorMessage)
}

export const setQFileError = (element: HTMLInputElement|QFile|null, errorMessage?: string|null) => {
    if (!element) {
        return 
    }

    const qInput = (element as QFile)
    const htmlInput = (element as HTMLInputElement)
    const id: string = (qInput?.$attrs.id as string|undefined) ?? qInput?.nativeEl.id ?? htmlInput?.id 
    const name: string = (qInput?.$attrs.name as string|undefined) ?? qInput?.nativeEl.name ?? htmlInput?.name

    setMyLabelClass(id, name, errorMessage)
}

export const setQCheckboxError = (element: HTMLInputElement|QCheckbox|null, errorMessage?: string|null) => {
    if (!element) {
        return 
    }

    const qInput = (element as QCheckbox)
    const htmlInput = (element as HTMLInputElement)
    const id: string = (qInput?.$attrs.id as string|undefined) ?? htmlInput?.id 
    const name: string = (qInput?.$attrs.name as string|undefined) ?? htmlInput?.name

    setMyLabelClass(id, name, errorMessage)
}

export const setMyLabelClass = (id?: string, name?: string, errorMessage?: string|null) => {
    if (!id && !name) {
        return 
    }
    if (!Platform.is.firefox) {
        return 
    }

    let findLabel = null
    if (id) {
        findLabel = document.querySelector(`.my-label > label[for="${id}"]`)
    }
    if (!findLabel && name) {
        findLabel = document.querySelector(`.my-label > label[for="${name}"]`)
    }
    if (findLabel) {
        if (errorMessage && errorMessage != '') {
            findLabel.classList.add('my-field-error')
        } else {
            findLabel.classList.remove('my-field-error')
        }
    }
}